import MyHeaderLabel from "../../components/MyHeaderLabel";
import BackButton from "../ui/BackButton";

export default function TransferStep({
  amount,
  onBack,
}: {
  amount: number;
  onBack: () => void;
}) {
  const accountName = "raashidh";
  const accountNumber = "7770000140688";
  //const amount = typeof total === "number" ? total.toFixed(2) : total || "0.00";
  const qrUrl = `00020101021126920014mv.favara.mpqr0108MALBMVMV0208MALBMVMV031377700001406880511+96075119101004IPAY6006LD04425204000053034625403***5802MV5907${accountName}62340509724C1IACG0817Quickpay Transfer80470014mv.favara.mpqr01252025-11-23T21:55:47.000006304746C`;


  return (
    <div className="space-y-4 animate-slideIn">
      <p className="text-gray-600">Scan QR with BML App</p>

      <div className="flex flex-col items-center gap-2">
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${qrUrl}`}
          className="rounded-lg shadow"
        />
        <b>{accountName}</b>
        <MyHeaderLabel label={accountNumber} />
        <MyHeaderLabel line label={`Amount: RF ${amount.toFixed(2)}`} />
      </div>

      <BackButton onClick={onBack} />
    </div>
  );
}